/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2021 Adobe
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
import React from 'react';
import PropTypes from 'prop-types';

import Portal from '../Portal/Portal';
import useEditorEvents from '../../utils/useEditorEvents';

const PortalPlacer = props => {
    const { selector, component: Cmp } = props;
    useEditorEvents();

    const elems = document.querySelectorAll(selector);

    const children = [...elems].map((elem, index) => {
        // Convert empty dataset keys to boolean values
        const dataset = {
            hostElement: elem,
            ...elem.dataset
        };
        Object.keys(dataset).forEach(key => {
            if (dataset[key] === '') {
                dataset[key] = true;
            }
        });

        return (
            <Portal key={index} selector={elem}>
                <Cmp {...dataset} />
            </Portal>
        );
    });

    return <>{children}</>;
};

PortalPlacer.propTypes = {
    selector: PropTypes.string.isRequired,
    component: PropTypes.func.isRequired
};

export default PortalPlacer;
